import React from "react";
import { ThemeProvider } from "styled-components";
import type { ThemeProviderProps } from "styled-components";
import { webDarkTheme } from "@ifgengineering/design-tokens/legacy";
import type { WebTheme } from "@ifgengineering/design-tokens/legacy";
import { DevToolsRail } from "@components/devTools/DevToolsRail";

interface V3ThemeProviderProps {
  children: ThemeProviderProps<WebTheme>["children"];
}

export const V3ThemeProvider = ({
  children,
}: V3ThemeProviderProps): JSX.Element => (
  <ThemeProvider theme={webDarkTheme}>
    <>
      <DevToolsRail />
      {children}
    </>
  </ThemeProvider>
);
